import { MdsIconKind } from "@/design-system/components/icon";
import { MDSIconButton, MDSIconButtonSize, MDSIconButtonVariant } from "@/mds";

type TProps = {
  navigateBack: () => void;
  navigateForward: () => void;
  canNavigateBack: boolean;
  canNavigateForward: boolean;
};

export const BackForwardButtons = ({
  navigateBack,
  navigateForward,
  canNavigateBack,
  canNavigateForward,
}: TProps) => {
  return (
    <>
      <MDSIconButton
        variant={MDSIconButtonVariant.OnChrome}
        size={MDSIconButtonSize.Medium}
        iconKind={MdsIconKind.LeftArrow}
        onClick={navigateBack}
        isDisabled={!canNavigateBack}
      />
      <MDSIconButton
        variant={MDSIconButtonVariant.OnChrome}
        size={MDSIconButtonSize.Medium}
        iconKind={MdsIconKind.RightArrow}
        onClick={navigateForward}
        isDisabled={!canNavigateForward}
      />
    </>
  );
};
